import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const INTEGRATIONS_QUERY_KEY = 'integrations';

export function useGetExternalIntegrationsQuery({
	impersonationContext,
	enabled = true,
	toastErrorMessage,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	toastErrorMessage?: string;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IExternalIntegration[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations`,
				}),
				'GET'
			);
		},
		queryKey: [INTEGRATIONS_QUERY_KEY, impersonationContext],
		meta: {
			toastErrorMessage,
			errorLogging: {
				category: 'ExternalIntegrations',
				action: 'LoadIntegrations-Error',
			},
		},
	});
}

export const invalidateIntegrationsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [INTEGRATIONS_QUERY_KEY, impersonationContext] });
